<template>
	<div style="margin-top: 1.25rem;">
		<div class="grid-content survey">
			<div class="date_search">
				<div class="search">
					<el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" value-format="yyyy-MM-dd" size="small" style="width: 100%;"
						:picker-options="pickerOptions">
					</el-date-picker>
				</div>
				<div class="sx">
					<div @click="sxDate(1)">7天</div>
					<div @click="sxDate(2)">30天</div>
					<div @click="sxDate">清空</div>
				</div>
			</div>
			<div class="box" v-loading="loading">
				<div class="con">
					<el-row :gutter="20">
						<el-col :span="8">
							<div class="item">
								<div class="t">
									<div class="icon">
										<i class="el-icon-coin"></i>
									</div>
									<div class="num">
										<div class="n">营业额</div>
										<div class="u">0.00</div>
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="8">
							<div class="item">
								<div class="t">
									<div class="icon">
										<i class="el-icon-document"></i>
									</div>
									<div class="num">
										<div class="n">订单笔数</div>
										<div class="u">0</div>
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="8">
							<div class="item">
								<div class="t">
									<div class="icon">
										<i class="el-icon-bank-card"></i>
									</div>
									<div class="num">
										<div class="n">实际支付金额</div>
										<div class="u">0.00</div>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="con">
					<el-row :gutter="20">
						<el-col :span="8">
							<div class="item">
								<div class="t">
									<div class="icon">
										<i class="el-icon-user-solid"></i>
									</div>
									<div class="num">
										<div class="n">用户人数</div>
										<div class="u">0</div>
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="8">
							<div class="item">
								<div class="t">
									<div class="icon">
										<i class="el-icon-s-custom"></i>
									</div>
									<div class="num">
										<div class="n">司机人数</div>
										<div class="u">0</div>
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="8">
							<div class="item">
								<div class="t">
									<div class="icon">
										<i class="el-icon-s-shop"></i>
									</div>
									<div class="num">
										<div class="n">合作门店</div>
										<div class="u">0</div>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<div class="grid-content" style="padding: 0;background-color: transparent;">
			<el-row :gutter="20">
				<el-col :span="12">
					<div class="grid-content">
						<div class="grid-content-title">
							<div class="name">司机接单榜前{{query.ranking}}名</div>
							<div class="ranking">
								<el-radio-group v-model="query.ranking" size="mini" @change="postTotal">
									<el-radio-button label="10"></el-radio-button>
									<el-radio-button label="50"></el-radio-button>
									<el-radio-button label="100"></el-radio-button>
								</el-radio-group>
							</div>
						</div>
						<div class="grid-content-list driver" style="margin-top: 0.9375rem;">
							<div class="common-table">
								<table class="header">
									<colgroup>
										<col width="12%">
										<col>
										<col width="18%">
										<col width="18%">
									</colgroup>
									<thead>
										<tr>
											<th>排名</th>
											<th>司机姓名</th>
											<th>接单量</th>
											<th>营业额</th>
										</tr>
									</thead>
								</table>
								<table class="body" v-loading="(loading && driver_ranking.length>0)?true:false">
									<colgroup>
										<col width="12%">
										<col>
										<col width="18%">
										<col width="18%">
									</colgroup>
									<thead>
										<template v-for="(item,index) in driver_ranking">
											<tr class="separation-row">
												<td colspan="10"></td>
											</tr>
											<tr class="content-row">
												<td>
													<div class="ranking">
														<span v-if="index==0" class="one">{{index+1}}</span>
														<span v-else-if="index==1" class="two">{{index+1}}</span>
														<span v-else-if="index==2" class="three">{{index+1}}</span>
														<span v-else>{{index+1}}</span>
													</div>
												</td>
												<td>
													<div class="names">{{item.rname}}</div>
												</td>
												<td>
													<div class="total">{{item.total}}单</div>
												</td>
												<td>
													<div class="amount">{{item.amount}}</div>
												</td>
											</tr>
										</template>
									</thead>
								</table>
							</div>
							<div v-if="loading && driver_ranking.length<=0" style="min-height: 20rem;"
								v-loading="loading"></div>
							<el-empty v-if="!loading && driver_ranking.length<=0" style="height: 20rem;"
								description="暂无排行数据" :image-size="100">
							</el-empty>
						</div>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="grid-content user">
						<div class="grid-content-title">
							<div class="name">用户消费榜前{{query.ranking}}名</div>
							<div class="ranking">
								<el-radio-group v-model="query.ranking" size="mini" @change="postTotal">
									<el-radio-button label="10"></el-radio-button>
									<el-radio-button label="50"></el-radio-button>
									<el-radio-button label="100"></el-radio-button>
								</el-radio-group>
							</div>
						</div>
						<div class="grid-content-list" style="margin-top: 0.9375rem;">
							<div class="common-table">
								<table class="header">
									<colgroup>
										<col width="12%">
										<col>
										<col width="18%">
										<col width="18%">
									</colgroup>
									<thead>
										<tr>
											<th>排名</th>
											<th>用户昵称</th>
											<th>下单量</th>
											<th>消费额</th>
										</tr>
									</thead>
								</table>
								<table class="body" v-loading="(loading && driver_ranking.length>0)?true:false">
									<colgroup>
										<col width="12%">
										<col>
										<col width="18%">
										<col width="18%">
									</colgroup>
									<thead>
										<template v-for="(item,index) in user_ranking">
											<tr class="separation-row">
												<td colspan="10"></td>
											</tr>
											<tr class="content-row">
												<td>
													<div class="ranking">
														<span v-if="index==0" class="one">{{index+1}}</span>
														<span v-else-if="index==1" class="two">{{index+1}}</span>
														<span v-else-if="index==2" class="three">{{index+1}}</span>
														<span v-else>{{index+1}}</span>
													</div>
												</td>
												<td>
													<div class="names">
														<span>{{item.name}}</span>
														<span class="id">ID:{{item.id}}</span>
													</div>
												</td>
												<td>
													<div class="total">{{item.total}}单</div>
												</td>
												<td>
													<div class="amount">{{item.amount}}</div>
												</td>
											</tr>
										</template>
									</thead>
								</table>
							</div>
							<div v-if="loading && user_ranking.length<=0" style="min-height: 20rem;"
								v-loading="loading"></div>
							<el-empty v-if="!loading && user_ranking.length<=0" style="height: 20rem;"
								description="暂无排行数据" :image-size="100">
							</el-empty>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: true,
				query: {
					ranking: 10,
					date: []
				},
				pickerOptions: {
					disabledDate: (time) => {
						const newDate = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
						return time.getTime() > newDate;
					}
				},
				survey: {
					a: "0.00",
					b: 0,
					c: "0.00",
					d: 0,
					e: 0,
					f: 0
				},
				user_ranking: [],
				driver_ranking: []
			};
		},
		created() {
			this.initDate();
		},
		methods: {
			sxDate(t = 0) {
				const end = new Date();
				const start = new Date();
				switch (t) {
					case 1:
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
						this.query.date = [this.$formatDay(start), this.$formatDay(end)];
						this.postTotal();
						break;
					case 2:
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
						this.query.date = [this.$formatDay(start), this.$formatDay(end)];
						this.postTotal();
						break;
					default:
						this.initDate();
				}
			},
			initDate() {
				const end = new Date();
				const start = new Date();
				this.query.date = [this.$formatDay(start), this.$formatDay(end)];
				this.postTotal();
			},
			postTotal() {
				const that = this;
				that.loading = true;
				that.$post('total', {
					ranking: that.query.ranking,
					date: that.query.date
				}).then(res => {
					setTimeout(function() {
						that.loading = false;
						that.user_ranking = res.data.user_ranking;
						that.driver_ranking = res.data.driver_ranking;
					}, 500);
				}).catch(e => {
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.survey .box {
		margin-top: 3rem;
		margin-bottom: 2rem;
	}

	.survey .box .con:nth-child(2) {
		margin-top: 2rem;
	}

	.survey .box .con .item {
		display: flex;
		justify-content: center;
	}

	.survey .box .con .item .t {
		display: flex;
		width: 70%;
		align-items: center;
	}

	.survey .box .con .item .t .icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 3.75rem;
		height: 3.75rem;
		border-radius: 50%;
		margin-right: 2.1875rem;
		background-color: #eff6ff;
	}

	.survey .box .con .item .t .icon i {
		color: #6af;
		font-size: 1.75rem;
	}

	.survey .box .con .item .t .num {
		flex: 1;
	}

	.survey .box .con .item .t .num .n {
		font-size: 0.875rem;
		color: #666;
	}

	.survey .box .con .item .t .num .u {
		font-family: 'WechatSans';
		font-size: 1.5rem;
		color: #000;
		margin-top: 0.25rem;
	}

	.driver .common-table table td,
	.user .common-table table td {
		height: 1rem;
		border: 0;
	}

	.driver .ranking,
	.user .ranking {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.driver .ranking span,
	.user .ranking span {
		width: 1.5rem;
		height: 1.5rem;
		line-height: 1.5rem;
		text-align: center;
		font-size: 0.875rem;
		font-weight: bold;
		border-radius: 0.25rem;
		background-color: #f0f0f0;
	}

	.driver .ranking span.one,
	.user .ranking span.one {
		color: white;
		background-color: #ff9800;
	}

	.driver .ranking span.two,
	.user .ranking span.two {
		color: white;
		background-color: #ffc107;
	}

	.driver .ranking span.three,
	.user .ranking span.three {
		background-color: #ffeb3b;
	}

	.driver .names,.user .names {
		font-weight: bold;
		font-size: 0.9375rem;
		padding-left: 0.625rem;
	}

	.user .names .id {
		color: #999;
		font-size: 0.75rem;
		padding-left: 0.625rem;
	}

	.driver .total,
	.user .total {
		font-size: 0.875rem;
		text-align: center;
	}

	.driver .amount,
	.user .amount {
		font-size: 0.875rem;
		text-align: center;
	}
</style>
